<app-modal [dismissable]="true" [title]="showPartnerName ? partnerName + ' - ' + ('QR Code' | translate) : ('QR Code' | translate)">
  <div class="modal-content">
    <div class="qr-modal-body">
      <div class="qr-code-display">
        <img [src]="getQrCodeUrl(400)" alt="Partner QR Code" class="qr-code-large" />
      </div>
      <p class="text-center text-muted mt-3">
       {{ description | translate }}
      </p>
    </div>
  </div>

  <div class="modal-actions">
<app-button label="{{ 'Download QR Code' | translate }}" buttonType="primary" icon="download" iconPosition="left"
      (onClick)="downloadQrCode()"></app-button>
  </div>
</app-modal>
